import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { fetchAuthSession } from 'aws-amplify/auth';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

// const apiProductURL = "https://0ehm5uf0oi.execute-api.us-east-2.amazonaws.com/dev/product/graphql";
const apiProductURL = `${environment.productApi}/graphql`;

interface PersonalRangoResponse {
  data: {
    getAllPersonalRango: any[]; // Ajusta esto según la estructura real de tus datos
  };
}

@Injectable({
  providedIn: 'root',
})
export class personalRangoService {
  private apiProduct = apiProductURL;

  constructor(private http: HttpClient) {}

  public async useQueryPersonalRango(): Promise<
    Observable<PersonalRangoResponse>
  > {
    const query = `
      query {
        getAllPersonalRango {
          tipoServicio
          categoriaServicio
          categoriaProducto
          subCategoriaProducto
          comentario
          destino
          nroPersonasPax {
            numPax
            id
          }
        }
      }
    `;

    try {
      const session = await fetchAuthSession();
      const token = session.tokens?.idToken?.toString();

      const headers = new HttpHeaders({
        'Content-Type': 'application/json; charset=UTF-8',
        Accept: 'application/json',
        ...(token && { Authorization: `Bearer ${token}` }),
      });

      return this.http.post<PersonalRangoResponse>(
        this.apiProduct,
        { query },
        { headers }
      );
    } catch (error) {
      const headers = new HttpHeaders({
        'Content-Type': 'application/json; charset=UTF-8',
        Accept: 'application/json',
      });

      return this.http.post<PersonalRangoResponse>(
        this.apiProduct,
        { query },
        { headers }
      );
    }
  }
}
